export default function getMondayDateFromWeek(formattedWeek) {
    const year = parseInt(formattedWeek.split('/')[0], 10);
    const weekNumber = parseInt(formattedWeek.split('/')[1], 10);
    const january10 = new Date(year, 0, 10);
    const january4 = new Date(year, 0, 4);
    const month = january4.getTime() - january10.getDay() * 86400000;
    return new Date(month + ((weekNumber - 1) * 7) * 86400000);
}
